export default class Resize{
    constructor(kv){

        this.kv = document.getElementById('p-kv');

    }

    /* ---------------------------------------------------

     -- リサイズ

    --------------------------------------------------- */

    set(_w,_h){

        this.kv.style.height = _h+'px';

    }


}